module.exports = __webpack_public_path__ + "media/src/assets/Images/ArrowButtonRight-d4232f24c44b649c3c9bb57450afbdcd.svg";